import { render } from "./WorkOrderStatusWidget.vue?vue&type=template&id=130e3f51"
import script from "./WorkOrderStatusWidget.vue?vue&type=script&lang=js"
export * from "./WorkOrderStatusWidget.vue?vue&type=script&lang=js"

import "./WorkOrderStatusWidget.vue?vue&type=style&index=0&id=130e3f51&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__